import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'ls-collapse-links',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './collapse-links.component.html',
    styleUrls: ['./collapse-links.component.scss'],
    standalone: true,
    imports: [MatListModule, NgFor, RouterLinkActive, RouterLink, MatIconModule, NgIf, MatButtonModule, MatIconModule]
})
export class CollapseLinksComponent {

    // @Input() opened: boolean = false;
    @Input() paths: { name: string, url: string, path: string }[];
    @Input() fragments: { id: string, label: string }[];
    @Output() openHelper = new EventEmitter<string>();

    scrollTo(id: string) {
        const e = document.getElementById(id);

        if (!e)
            return;

        e.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        setTimeout(() => {
            e.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 300);

    }

}
